export const questionnairDependencies = {
  dependencie_creation_error: 'Dependence creation has failed',
  dependencie_creation_success: 'Dependence creation has succeeded',
  questionnair_dependencie_sequencing: 'Sequencing',
  questionnair_dependencie_nextQuestion: 'Next question',
  cant_delete_text: 'This question cannot be deleted. Check its dependencies.',
  condition: 'Condition',
  questionnaire_dependency_error: 'Error while getting dependencies'
};
